import { Box, Card, CardContent, Grid, Link, SvgIcon, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'next-i18next';

import type { AppointmentInformation } from '../AppointmentReview';

import * as iconMap from '@src/icons';
import { useFormSectionStore } from '@src/store';

export default function AppointmentCard({ title, content, icon, editSectionIndex }: Readonly<AppointmentInformation>) {
	// if mobile stepper component is removed use TAGSvgIcon instead
	const Icon = iconMap[icon];
	const { setActiveSection } = useFormSectionStore((store) => store);
	const { t } = useTranslation('appointmentReview');
	return (
		<Card elevation={0} variant="outlined" sx={{ height: '100%' }} className="appointment-card">
			<CardContent sx={{ height: '100%' }}>
				<Grid container sx={{ height: '100%' }}>
					<Grid xs={11} item>
						<Typography variant="header4" color="text.primary">
							{title}
						</Typography>
						<Grid container direction="column" mt={2}>
							{content.map((text, index) => (
								<Typography
									key={index}
									variant={index === 0 || index === 3 ? 'bodyLargeBook' : 'bodyMediumBook'}
									color="text.secondary"
								>
									{text}
								</Typography>
							))}
						</Grid>
					</Grid>
					<Grid item xs={1}>
						<Grid container direction="column" alignItems="center" sx={{ height: '100%' }}>
							<Box sx={{ marginBottom: 'auto', height: '2rem', alignItems: 'center', display: 'flex' }}>
								{typeof editSectionIndex === 'number' && editSectionIndex >= 0 ? (
									<Link
										color="secondary.main"
										href="#"
										underline="none"
										variant="bodyMediumSemiBold"
										onClick={() => setActiveSection(editSectionIndex)}
									>
										{t('editCard')} <Box sx={visuallyHidden}>{title}</Box>
									</Link>
								) : null}
							</Box>
							<SvgIcon
								viewBox="0 0 32 32"
								sx={{ height: 32, width: 32 }}
								data-test-id="icon_card_appointment"
							>
								<Icon />
							</SvgIcon>
						</Grid>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
}
